import React, { useEffect } from 'react';
import '@justifi/webcomponents/dist/module/justifi-dispute-management';
import {
  Modal,
  ModalControlModalProps,
  useModalLoadingState,
} from '@weave/design-system';
import { WebComponentUIContext } from '@weave/schema-gen-ts/dist/schemas/payments-platform/justifi-integration/justifi_integration.pb';
import { useCreateWebComponentToken } from 'apis/payments/justifi-integration/v1/queries/use-create-web-component-token';

interface DisputeDetailsModalBodyProps {
  closeModal(): void;
  locationId: string;
  disputeId: string;
}
interface DisputeDetailsModalProps extends DisputeDetailsModalBodyProps {
  modalProps: ModalControlModalProps;
}
export const DisputeDetailsModal = ({
  modalProps,
  ...props
}: DisputeDetailsModalProps) => {
  return (
    <Modal {...modalProps} maxWidth={400}>
      <DisputeDetailsModalBody {...props} />
    </Modal>
  );
};

export const DisputeDetailsModalBody = ({
  closeModal,
  locationId,
  disputeId,
}: DisputeDetailsModalBodyProps) => {
  const { authToken, loading } = useCreateWebComponentToken({
    locationId,
    disputeId,
    webComponentUiContext:
      WebComponentUIContext.WEB_COMPONENT_UI_CONTEXT_DISPUTE_MANAGEMENT,
  });
  const { setLoading } = useModalLoadingState();

  useEffect(() => {
    setLoading(loading);
  }, [loading]);

  return (
    <>
      <Modal.Header onClose={closeModal}></Modal.Header>
      <Modal.Body>
        <div>
          <justifi-dispute-management
            auth-token={authToken}
            dispute-id={disputeId}
          ></justifi-dispute-management>
        </div>
      </Modal.Body>
    </>
  );
};
